import React, { FC } from "react";

import CampaignBuilderForm from "../../components/redesign/modules/CampaignBuilderForm";

const CampaignTemplateCreatePageRedesign: FC = () => <CampaignBuilderForm mode="template" />;

export default CampaignTemplateCreatePageRedesign;
